// extracted by mini-css-extract-plugin
export var closeButton = "_gh-2";
export var closeButtonIcon = "_gh-3";
export var lightboxContent = "_gh-1";
export var lightboxOverlay = "_gh-0";